/**
 * Bangladeshi bank list used by the Bank Name fields.
 *
 * Bangladesh Bank (the central bank) does not expose a public, guaranteed-free
 * REST API for scheduled-bank names, so the list is bundled locally to keep the
 * forms working offline and without an API key. The SearchableSelect that
 * consumes this also allows adding a custom name, so banks missing from this
 * list can still be entered.
 */

export interface BankOption {
  value: string;
  label: string;
}

/** Scheduled banks of Bangladesh (state-owned, specialised, private, foreign). */
export const BANGLADESHI_BANKS: string[] = [
  // ─── State-owned commercial banks ───
  'Sonali Bank',
  'Janata Bank',
  'Agrani Bank',
  'Rupali Bank',
  'BASIC Bank',
  'Bangladesh Development Bank (BDBL)',
  // ─── Specialised banks ───
  'Bangladesh Krishi Bank',
  'Rajshahi Krishi Unnayan Bank',
  'Karmasangsthan Bank',
  'Probashi Kallyan Bank',
  // ─── Private commercial banks ───
  'AB Bank',
  'Bank Asia',
  'BRAC Bank',
  'Bengal Commercial Bank',
  'Citizens Bank',
  'City Bank',
  'Community Bank Bangladesh',
  'Dhaka Bank',
  'Dutch-Bangla Bank',
  'Eastern Bank',
  'First Security Islami Bank',
  'Global Islami Bank',
  'ICB Islamic Bank',
  'IFIC Bank',
  'Islami Bank Bangladesh',
  'Jamuna Bank',
  'Meghna Bank',
  'Mercantile Bank',
  'Midland Bank',
  'Modhumoti Bank',
  'Mutual Trust Bank',
  'National Bank',
  'National Credit & Commerce Bank (NCC)',
  'NRB Bank',
  'NRB Commercial Bank',
  'One Bank',
  'Padma Bank',
  'Premier Bank',
  'Prime Bank',
  'Pubali Bank',
  'Shimanto Bank',
  'Social Islami Bank',
  'South Bangla Agriculture & Commerce Bank',
  'Southeast Bank',
  'Standard Bank',
  'Trust Bank',
  'Union Bank',
  'United Commercial Bank',
  'Uttara Bank',
  // ─── Foreign commercial banks ───
  'Bank Alfalah',
  'Citibank N.A.',
  'Commercial Bank of Ceylon',
  'Habib Bank',
  'HSBC Bangladesh',
  'National Bank of Pakistan',
  'Standard Chartered Bangladesh',
  'State Bank of India (Bangladesh)',
  'Woori Bank',
];

/** Pre-built options for the shared SearchableSelect component. */
export const BANGLADESHI_BANK_OPTIONS: BankOption[] = BANGLADESHI_BANKS.map((name) => ({
  value: name,
  label: name,
}));